import {
  IAddOfferToComparisonResponse400,
  IAddOfferToComparisonResponseError,
} from '../../../../repositories/offers-comparison/v2/add-offer-to-comparison';

export const mapDeleteOfferFromComparisonResponseError = (
  response: IAddOfferToComparisonResponseError,
): IAddOfferToComparisonResponse400 => {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
